/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ContentLock/theme';

export const ContentLockTheme = theme;
